import { TableBody, TableCell, TableRow } from "@mui/material";
import { Loader } from "@stories/atoms/Loaders/Loader/Loader";

interface DataLoadingRowProps {
  colSpan: number;
}
export const DataLoadingRow = ({ colSpan }: DataLoadingRowProps) => {
  return (
    <TableRow>
      <TableCell
        align="center"
        colSpan={colSpan}
        sx={{ py: 3, textAlign: "center" }}
      >
        <Loader />
      </TableCell>
    </TableRow>
  );
};
